
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10.907 10.93"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 6941","d":"M10.621 8.021L9.096 6.5a1.015 1.015 0 00-1.689.381 1.038 1.038 0 01-1.2.654A4.7 4.7 0 013.376 4.7a.987.987 0 01.654-1.2 1.015 1.015 0 00.381-1.689L2.886.286a1.088 1.088 0 00-1.471 0L.38 1.321C-.655 2.411.489 5.3 3.049 7.858s5.448 3.759 6.537 2.669l1.035-1.035a1.088 1.088 0 000-1.471z","fill":"#fff"}})])
          )
        }
      }
    